import { FileText, Link as LinkIcon, Trash2 } from "lucide-react"
import { deleteAttachment } from "@/api/kuizy"

export default function AttachmentItem({ item, refresh }) {
    const handleDelete = async () => {
        if (!window.confirm("ลบรายการนี้?")) return
        await deleteAttachment(item.id)
        refresh()
    }

    return (
        <div className="bg-white border rounded-xl px-4 py-3 flex justify-between items-center">
            <div className="flex items-center gap-3 text-sm">
                {item.type === "youtube" || item.type === "link" ? (
                    <LinkIcon size={16} className="text-green-500" />
                ) : (
                    <FileText size={16} className="text-blue-500" />
                )}
                {item.name}
            </div>

            <button
                onClick={handleDelete}
                className="text-gray-400 hover:text-red-500"
            >
                <Trash2 size={16} />
            </button>
        </div>
    )
}
